import { ServerModel } from '../../../models/serverModel';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';

interface Props {
  readonly servers: ServerModel[];
  readonly onSelectServer: (serverId: string) => void,
}

export const ServerList = (props: Props) => {
  return (
    <Grid container spacing={2}>
      {props.servers.map(kannelServer => (
        <Grid item xs={12} sm={6} md={6} lg={3} key={kannelServer.id}>
          <Card>
            <CardHeader title={kannelServer.displayName} subheader={`(serverId: ${kannelServer.id})`} />
            <CardActions>
              <Button
                onClick={() => props.onSelectServer(kannelServer.id)}
                size="small"
              >Show configuration</Button>
            </CardActions>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export default ServerList;
